/* global AWIN */
import createAdapter from './createAdapter'
import { getItem, setItem, removeItem } from '../../storeManager'
import { environment } from 'js/config'
import { excludeVAT } from '../../utils'

export const awin = createAdapter(() => true, {
  trackPurchase(transactionId, coupon, orderValue, currency) {
    if (!getItem('state')) {
      throw new Error('awinAdapter.ts error: no state saved')
    }

    const { user: userState, locale: localeState } = JSON.parse(
      getItem('state') as string,
    )
    const awc = getItem('awinAwc')
    const userId = userState.profile.id || userState.limitedProfile.id
    const country = userState.profile.country || localeState.country
    let merchantId: string = '113414'

    const couponUpper = coupon ? coupon.toUpperCase() : ''
    const isAwinCoupon =
      couponUpper === 'AWINCA' ||
      couponUpper === 'AWINUS' ||
      awc?.toUpperCase() === 'AWINCA' ||
      awc?.toUpperCase() === 'AWINUS'

    if (userId && (awc || isAwinCoupon)) {
      if (coupon) {
        const couponUpper = coupon.toUpperCase()
        switch (couponUpper) {
          case 'AWINCA':
            merchantId = '119213'
            coupon = 'AwinCA'
            break
          case 'AWINUS':
            merchantId = '119217'
            coupon = 'AwinUS'
            break
        }
      } else if (awc) {
        const awcUpper = awc.toUpperCase()
        switch (awcUpper) {
          case 'AWINCA':
            merchantId = '119213'
            coupon = 'AwinCA'
            break
          case 'AWINUS':
            merchantId = '119217'
            coupon = 'AwinUS'
            break
        }
      } else {
        coupon = null
      }

      const amount = parseFloat(excludeVAT(orderValue, country)).toFixed(2)

      // Ensure MasterTag is loaded before setting conversion tag
      const loadMasterTag = (): Promise<void> => {
        return new Promise((resolve) => {
          const existingScript = document.querySelector(
            'script[src*="dwin1.com/"]',
          )

          if (
            typeof AWIN !== 'undefined' &&
            typeof AWIN.Tracking !== 'undefined'
          ) {
            resolve()
            return
          }

          // If script exists but AWIN not ready, wait for it
          if (existingScript) {
            // Script is loading, resolve immediately and let retry logic handle it
            resolve()
            return
          }

          const scriptUrl = `https://www.dwin1.com/${merchantId}.js`
          const awMastertag = document.createElement('script')
          awMastertag.src = scriptUrl
          awMastertag.type = 'text/javascript'
          awMastertag.async = true

          awMastertag.onload = () => {
            resolve()
          }
          awMastertag.onerror = () => {
            resolve()
          }

          document.getElementsByTagName('body')[0].appendChild(awMastertag)
        })
      }

      const pixelUrl =
        'https://www.awin1.com/sread.img?tt=ns&tv=2&merchant=' +
        merchantId +
        '&amount=' +
        amount +
        '&ch=aw&parts=DEFAULT:' +
        amount +
        '&ref=' +
        transactionId +
        '&vc=' +
        (coupon || '') +
        '&cr=' +
        currency +
        '&testmode=' +
        (environment === 'production' ? 0 : 1)

      const awPixel = new Image(0, 0)
      awPixel.src = pixelUrl
      document.getElementsByTagName('body')[0].appendChild(awPixel)

      const maxRetries = 100
      const checkInterval = 100
      let retryCount = 0

      const runAwinTracking = () => {
        if (typeof AWIN != 'undefined' && typeof AWIN.Tracking != 'undefined') {
          AWIN.Tracking.Sale = {
            amount: String(amount),
            channel: 'aw',
            orderRef: String(transactionId),
            parts: 'DEFAULT:' + amount,
            currency: String(currency),
            voucher: String(coupon || ''),
            test: String(environment === 'production' ? 0 : 1),
          }
          AWIN.Tracking.run()
          removeItem('awinAwc')
        } else if (retryCount < maxRetries) {
          retryCount++
          setTimeout(runAwinTracking, checkInterval)
        } else {
          console.error(
            'AWIN object not available after max retries. Tracking failed.',
          )
          removeItem('awinAwc')
        }
      }

      // Load MasterTag first, then start tracking
      ;(async () => {
        await loadMasterTag()
        runAwinTracking()
      })()
    }
  },
  saveId() {
    const awc = new URLSearchParams(document.location.search).get('awc')
    if (awc) {
      setItem('awinAwc', awc)
    }
  },
})
